import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RfpClientOneFileAllPage } from '@/pages/rfp/client/RfpClientOneFileAll/RfpClientOneFileAllPage';
/**
 * クライアント：ファイル共有一括送付ページ（認証以外のアクセス制限）
 * NOTE: ページ構成統一のため作成してあります。アクセス制限等ができた場合ここに処理を追加する
 */
export const RfpClientOneFileAll = (props) => (_jsx(RfpClientOneFileAllPage, Object.assign({}, props)));
